import { module } from 'angular';
import kformComponent from './kform.component';
import kformComponentDirective from './component/kform-component.directive';
import kformComponentTooltipDirective
	from './component-tooltip/kform-component-tooltip.directive';
import kformContentComponent from './content/kform-content.component';
import kformFormDirective from './form/kform-form.directive';
import kformHtmlElementDirective from './html-element/kform-html-element.directive';
import kformScopeFactory from './form/kform-scope.factory';
// eslint-disable-next-line unicorn/prevent-abbreviations
import kformDevToolbar from './dev-toolbar/kform-dev-toolbar.component';
import kformElementDirective from './element/kform-element.directive';
import kformErrorsDirective from './errors/kform-errors.directive';
import kformFileLabelComponent from './file-label/kform-file-label.component';
import kformInputMaskDirective from './input-mask/kform-input-mask.directive';
import kformInputPasswordDirective from './input-password/kform-input-password.directive';
import kformMaxDirective from './max/kform-max.directive';
import kformMinDirective from './min/kform-min.directive';
import kformScriptEditorComponent from './script-editor/kform-script-editor.component';
import kformSelectItemDirective from './select-item/kform-select-item.directive';
import kformTabAttributComponent from './tab-attribut/kform-tab-attribut.component';
import kformTabFileComponent from './tab-file/kform-tab-file.component';
import kformTabFileMultipleComponent from '~/components/kform/tab-file-multiple/kform-tab-file-multiple.component';
import kformTabFormComponent from './tab-form/kform-tab-form.component';
import kformTabHistoryComponent from './tab-history/kform-tab-history.component';
import kformTabOpentextComponent from './tab-opentext/kform-tab-opentext.component';
import kformTabRepreComponent from './tab-repre/kform-tab-repre.component';
import kformTabRightsComponent from './tab-rights/kform-tab-rights.component';
import kformTabWfComponent from './tab-wf/kform-tab-wf.component';
import kformTreeComponent from './tree/kform-tree.component';
import kformToolbarComponent from './toolbar/kform-toolbar.component';
import customValidatorDirective from './custom-validator/custom-validator.directive';

import './kform.run';
import './kform.scss';

// kform components
import './components/common/common.run';
import './components/textfield/textfield.config';
import './components/textfield/textfield.run';
import './components/button/button.config';
import './components/button/button.run';
import './components/cardgrid/cardgrid.config';
import './components/cardgrid/cardgrid.run';
import './components/checkbox/checkbox.config';
import './components/checkbox/checkbox.run';
import './components/columns/columns.config';
import './components/columns/columns.run';
import './components/currency/currency.config';
import './components/currency/currency.run';
import './components/custom/custom.config';
import './components/custom/custom.run';
import './components/datagrid/datagrid.config';
import './components/datagrid/datagrid.run';
import './components/datetime/datetime.config';
import './components/datetime/datetime.run';
import './components/email/email.config';
import './components/email/email.run';
import './components/fieldset/fieldset.config';
import './components/fieldset/fieldset.run';
import './components/file-current/file-current.config';
import './components/file-current/file-current.run';
import './components/geo/geo.config';
import './components/geo/geo.run';
import './components/htmlelement/htmlelement.config';
import './components/htmlelement/htmlelement.run';
import './components/json-editor/json-editor.config';
import './components/json-editor/json-editor.run';
import './components/kid/kid.config';
import './components/kid/kid.run';
import './components/kpath/kpath.config';
import './components/kpath/kpath.run';
import './components/ktable/ktable.config';
import './components/ktable/ktable.run';
import './components/name/name.config';
import './components/name/name.run';
import './components/number/number.config';
import './components/number/number.run';
import './components/panel/panel.config';
import './components/panel/panel.run';
import './components/phone-number/phone-number.config';
import './components/phone-number/phone-number.run';
import './components/postal-address/postal-address.config';
import './components/postal-address/postal-address.run';
import './components/qr/qr.config';
import './components/qr/qr.run';
import './components/qty/qty.config';
import './components/qty/qty.run';
import './components/radio/radio.config';
import './components/radio/radio.run';
import './components/repre/repre.config';
import './components/repre/repre.run';
import './components/select/select.config';
import './components/select/select.run';
import './components/smart-field/smart-field.config';
import './components/smart-field/smart-field.run';
import './components/tabs/tabs.module';
import './components/password/password.config';
import './components/password/password.run';
import './components/text-editor/text-editor.config';
import './components/textarea/textarea.config';
import './components/textarea/textarea.run';
import './components/uri/uri.config';
import './components/uri/uri.run';
import './components/well/well.config';
import './components/well/well.run';

export default module('app')

	.component('kform', kformComponent)
	.component('kformContent', kformContentComponent)
	.component('kformDevToolbar', kformDevToolbar)
	.component('kformFileLabel', kformFileLabelComponent)
	.component('kformTabAttribut', kformTabAttributComponent)
	.component('kformTabFile', kformTabFileComponent)
	.component('kformTabFileMultiple', kformTabFileMultipleComponent)
	.component('kformTabForm', kformTabFormComponent)
	.component('kformTabHistory', kformTabHistoryComponent)
	.component('kformTabOpentext', kformTabOpentextComponent)
	.component('kformTabRepre', kformTabRepreComponent)
	.component('kformTabRights', kformTabRightsComponent)
	.component('kformTabWf', kformTabWfComponent)
	.component('kformToolbar', kformToolbarComponent)
	.component('kformTree', kformTreeComponent)
	.component('kformScriptEditor', kformScriptEditorComponent)

	.directive('customValidator', customValidatorDirective)
	.directive('kformComponent', kformComponentDirective)
	.directive('kformComponentTooltip', kformComponentTooltipDirective)
	.directive('kformElement', kformElementDirective)
	.directive('kformErrors', kformErrorsDirective)
	.directive('kformForm', kformFormDirective)
	.directive('kformHtmlElement', kformHtmlElementDirective)
	.directive('kformInputMask', kformInputMaskDirective)
	.directive('kformInputPassword', kformInputPasswordDirective)
	.directive('kformMax', kformMaxDirective)
	.directive('kformMin', kformMinDirective)
	.directive('kformSelectItem', kformSelectItemDirective)

	.factory('KformScope', kformScopeFactory)

	.name;
